import React, { useState } from 'react';
import { FaHome, FaUsers, FaCogs, FaBriefcase, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo.svg';
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link"; // 👈 import novo

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav>
      <div className="nav-left">
         <HashLink smooth to="/#home" onClick={closeMenu}><img src={logo} alt="Logo Amaratech" className="logo" /></HashLink>
      </div>

      {/* Botão hamburguer (mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Links */}
      <div className={`nav-right ${menuOpen ? "active" : ""}`}>
        <HashLink smooth to="/#home" onClick={closeMenu}><FaHome /> Home</HashLink>
        <HashLink smooth to="/#sobre" onClick={closeMenu}><FaUsers /> Sobre nós</HashLink>
        <HashLink smooth to="/#servicos" onClick={closeMenu}><FaCogs /> Serviços</HashLink>
        <HashLink smooth to="/#clientes" onClick={closeMenu}><FaBriefcase /> Clientes</HashLink>
        <HashLink smooth to="/#contato" onClick={closeMenu}><FaEnvelope /> Contato</HashLink>
        <Link to="/neuroscan" onClick={closeMenu} className="text-[#009cfe] font-semibold">
          Neuroscan
        </Link>
      </div>
    </nav>
  );
}
